module.exports = __webpack_public_path__ + "media/images/home/scam-94ecc0153fd4d8da5d0bf52dc012586c.svg";